import {z} from '@hono/zod-openapi';

/** The alphabetically sorted make identifiers Alpha knows. */
export const priceReportCatalogMakesResponseSchema = z
  .array(z.string())
  .openapi('PriceReportCatalogMakesResponse');
